<div class="dialog-container">
    <mat-form-field>
      <mat-label>Select Column</mat-label>
      <mat-select (selectionChange)="addColumn($event.value)">
        <mat-option *ngFor="let column of allColumns" [value]="column">{{ bus_nm[column] }}</mat-option>
      </mat-select>
    </mat-form-field>
  
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <!-- Serial Number Column -->
      <ng-container matColumnDef="serial">
        <th mat-header-cell *matHeaderCellDef>serial</th>
        <td mat-cell *matCellDef="let index = index">{{index+1}}</td>
      </ng-container>
  
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Column Name</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      

      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>Value</th>
        <td mat-cell *matCellDef="let row"><input matInput [(ngModel)]="row.value" placeholder="Enter filter criteria"></td>
      </ng-container>
  
      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="deleteRow(row)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>
  
      <!-- Header Row Definition -->
      <tr mat-header-row *matHeaderRowDef="['serial', 'name','value' ,'action']"></tr>
      <!-- Row Definition -->
      <tr mat-row *matRowDef="let row; columns: ['serial', 'name','value' ,'action']"></tr>
    </table>
  
    <br>
  
    <div class="button-container">
      <button mat-button (click)="apply()">Apply</button>
      <button mat-button style="background-color: red;" color="danger" (click)="cancel()">Cancel</button>
    </div>
  </div>
  
